'use strict';
import {settings} from '../../variables.js'
var angularTemplatesBase = settings.angularTemplatesBase
var staticBase = settings.staticBase

angular.
module('faq')
.component('faqform', {
    templateUrl: angularTemplatesBase+'faq/faq.template.html?2',
    bindings: {
        source: '@'
    },
    controller: ['$routeParams', 'Faq', '$location', '$cookies',
        function ReviewFormCtrl($routeParams, Faq, $location, $cookies) {

        this.$onInit = function () {
            var self = this;

            console.log(self.source);

            self.faq = Faq.get();
            self.disable_btn = false;
            self.step = 'start';

            self.send_form = function(){
                self.disable_btn = true;
                self.faq.source = self.source;
                self.faq.$save(
                    function(response){
                        self.step = 'complete';
                        self.disable_btn = false;
                        ym(44803777, 'reachGoal', 'SENT_QUESTION');
                    },
                    function(response){
                        self.errors = response.data;
                        self.disable_btn = false;
                    }
                );
            }
        }

    }]
});